import { Button, Modal, ModalBody, ModalHeader, Table } from 'react-bootstrap';
import { MarketSignal } from '@/modules/market-signals/model/market-signals/market-signal';
import { SignalEntryComponent } from '@/modules/market-signals/components/market-signals/signal-entry-component';

export default function MarketSignalTranslationModal({
  signal,
  onClose,
  entry: MarketSignalScrollerEntry,
}: {
  signal?: MarketSignal;
  onClose: () => void;
  entry: SignalEntryComponent;
}) {
  return (
    <Modal
      show={!!(signal && signal.originalLanguageVersion)}
      size={'lg'}
      onBackdropClick={onClose}
      onHide={onClose}
    >
      <ModalHeader>
        <div className={'d-flex w-100 justify-content-between align-items-center'}>
          <div className={'h3'}>
            <span>Translation Details</span>
          </div>
          <Button onClick={onClose} variant={'warning'}>
            Close
          </Button>
        </div>
      </ModalHeader>

      <ModalBody>
        <Table>
          <thead>
            <tr>
              <th>Translated using Google Translate</th>
              <th>Original ({signal?.originalLanguage})</th>
            </tr>
          </thead>
          <tbody className={'small'}>
            <tr>
              <td>
                {signal && (
                  <MarketSignalScrollerEntry signal={signal} showTranslationLink={false} />
                )}
              </td>
              <td>
                {signal?.originalLanguageVersion && (
                  <MarketSignalScrollerEntry
                    signal={signal.originalLanguageVersion}
                    showTranslationLink={false}
                  />
                )}
              </td>
            </tr>
          </tbody>
        </Table>
      </ModalBody>
    </Modal>
  );
}
